import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js/max';
import { debounceTime, tap } from 'rxjs/operators';
import { EMAIL_REGEX } from 'src/app/app.constants';

export class CustomValidators {

    static noWhitespaceValidator(control: FormControl) {
        if (control.value === null || control.value === '') {
            return null;
        }
        if (!(control.value instanceof Date)) {
            const isWhitespace = (control.value || '').trim().length === 0;
            return isWhitespace ? {whitespace: true} : null;
        }
    }

    static checkPasswordsValidator(control: FormControl) {
        const form = control.parent;

        if (form && (form.get('password').value !== form.get('confirmPassword').value)) {
            return { passwordNotEqual: true };
        }

        return null;
    }

    static isPasswordValid(control: FormControl) {
        if (control.value === null || control.value === '') {
            return null;
        }
        
        // Check if it has at least 8 characters
        if (control.value.length < 8) {
            return { invalidPassword: true };
        }

        // Check if it has at least one lowercase letter
        if (!/[a-z]/.test(control.value)) {
            return { invalidPassword: true };
        }

        // Check if it has at least one uppercase letter
        if (!/[A-Z]/.test(control.value)) {
            return { invalidPassword: true };
        }

        // Check if it has at least one digit
        if (!/\d/.test(control.value)) {
            return { invalidPassword: true };
        }

        // Check if it has at least one special character
        if (!/[^a-zA-Z0-9]/.test(control.value)) {
            return { invalidPassword: true };
        }

        return null;
    }

    static checkDateStringContent(date: string) {
        if (date) {
            const str = date.split('/');
            if (str[0] && str[0].length > 2 && str[1]) {
                date = str[0].slice(0, 2) + '/' + str[0][2] + str[1][0] + '/' + str[1][1] + str[2];
            } else if (str[1] && str[1].length > 2) {
                date = str[0] + '/' + str[1].slice(0, 2) + '/' + str[1][2] + str[2];
            }

            return date;
        }
    }

    static phone(control: AbstractControl) {
        if (control.value) {
            const isValid = isValidPhoneNumber(control.value, {
                defaultCountry: 'DE',
                defaultCallingCode: '49',
            });
            if (!isValid) {
                return { phoneNumberInvalid: !isValid };
            }
        }
        return null;
    }

    static email(control: AbstractControl) {
        if (control.value) {
            const isPatternInvalid = Validators.pattern(EMAIL_REGEX)(control);
            if (isPatternInvalid) {
                return { invalidEmail: true };
            }
        }
        return null;
    }

    /**
     * Util method to enable or disable fields when the control param has a value change
     *
     * @param control - main field, we noticed changes in it
     *                  to enable or disable the list of dependent fields;
     * @param dependentFields - subordinate fields;
     * @param clear - Flag to clear field;
     * @param fn - validation.
     */
    static enableFieldsOnValueChange(
        control: AbstractControl,
        dependentFields: Array<AbstractControl>,
        clear: boolean,
        fn: (control: AbstractControl) => boolean
    ) {
        control.valueChanges
            .pipe(
                debounceTime(300),
                tap(() =>
                    dependentFields.forEach((field) => {
                        if (fn(field)) {
                            field.enable();
                        } else {
                            field.disable();
                            if (clear) {
                                field.setValue(null);
                            }
                        }
                        field.updateValueAndValidity();
                    })
                )
            )
            .subscribe();
    }
}
